<div class="mfe-pgh-device-inventory-styles mat-typography">
  <div style="display: flex;width: 100%;position: relative;justify-content: flex-end;">
    <div modal-close>
      <button mat-icon-button class="close-button mat-icon-button" sf-aria-label="Global_Close_Window" matDialogClose>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div mat-dialog-title class="mfe-header-h4 mfe-pgh-device-inventory-confirmation-dialog-title"
    [ngClass]="data.contextData?.titleLeftAligned? 'left-aligned' : ''">
    <adp-label labelKey="{{data.title}}" [context]="data.contextData"></adp-label>
  </div>

  @if (!data.isPhoneDeviceView) {
    <div mat-dialog-content class="mfe-body-1" style="overflow-y:hidden; margin: 0 -24px 20px;"><adp-label labelKey="{{data.message}}" [context]="data.contextData"></adp-label></div>
  }

  @if (data.isPhoneDeviceView) {
    <div mat-dialog-content class="mfe-body-1" style="overflow-y:hidden; margin: 0 -24px 20px;">
      <div><adp-label labelKey="{{data.message}}" [context]="data.contextData"></adp-label></div>
    </div>
  }

  @if (data.isPhoneDeviceView) {
    <form [formGroup]="form">
      <div mat-dialog-content class="mfe-body-2" style="margin: 0 -24px 10px;"><adp-label labelKey="Modal_PhoneNumber_Title"></adp-label></div>
      <div class="w-100 mb-25">
        <input matInput class="w-100" formControlName="phoneNumber" [pghNumber]="'####'" [pghNumberLength]="4" sf-aria-label="Global_Modal_Remove_Device">
        @if (hasError) {
          <div class="mat-error"><adp-label labelKey="Modal_Error_InvalidPhoneNumber"></adp-label></div>
        }
      </div>
    </form>
  }

  @if (!data.contextData?.hideButtons) {
    <div modal-footer>
      <div class="row reverse-wrap">
        <div class="col-md-6">
          <button mat-stroked-button color="primary" class="border-0" [mat-dialog-close]="false" gtmClick="">
            <adp-label labelKey="{{data.cancelButtonText}}"></adp-label>
          </button>
        </div>
        <div class="col-md-6">
          <button [disabled]="data.isPhoneDeviceView && !isPhoneNumberMatching" mat-flat-button color="accent" [mat-dialog-close]="true" gtmClick="">
            <adp-label labelKey="{{data.confirmButtonText}}"></adp-label>
          </button>
        </div>
      </div>
    </div>
  }
</div>
